import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Shield, HeartPulse, Leaf, Droplets, RefreshCw, CheckCircle2 } from 'lucide-react';
const ingredients = [{
  icon: <Activity className="text-forest-green" size={24} data-id="element-81" />,
  title: 'Darm nach OP',
  desc: 'was passiert im Gewebe'
}, {
  icon: <Shield className="text-forest-green" size={24} data-id="element-82" />,
  title: 'Leinsamen',
  desc: 'schützende Schleimschicht für die Darmwand'
}, {
  icon: <HeartPulse className="text-forest-green" size={24} data-id="element-83" />,
  title: 'Mariendistel',
  desc: 'unterstützt Leberregeneration nach Narkose'
}, {
  icon: <RefreshCw className="text-forest-green" size={24} data-id="element-84" />,
  title: 'Inulin & Topinambur',
  desc: 'Wiederaufbau der Darmflora'
}, {
  icon: <Droplets className="text-forest-green" size={24} data-id="element-85" />,
  title: 'Artischocke',
  desc: 'regt Gallenproduktion an, fördert Verdauung'
}, {
  icon: <Leaf className="text-forest-green" size={24} data-id="element-86" />,
  title: 'Johannisbrotmehl',
  desc: 'reguliert Darmbewegung sanft und natürlich'
}];
export function ProductExplanation() {
  return <section className="w-full py-16 px-4 md:px-8 bg-off-white border-y border-warm-brown/10 mt-12" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-89">
          <h2 className="font-handwritten text-4xl md:text-5xl text-forest-green font-bold mb-4" data-id="element-90">
            Wie der Darm nach einem Trauma wieder stark wird
          </h2>
          <div className="inline-flex items-center gap-2 bg-forest-green/10 text-forest-green px-4 py-2 rounded-full font-medium text-sm" data-id="element-91">
            <CheckCircle2 size={18} data-id="element-92" />
            <span data-id="element-93">100% pflanzlich, keine künstlichen Zusätze</span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-94">
          {ingredients.map((item, index) => <motion.div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-warm-brown/5 flex flex-col items-center text-center gap-3 hover:shadow-md transition-shadow" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-95">
              <div className="w-12 h-12 rounded-full bg-cream flex items-center justify-center mb-2" data-id="element-96">
                {item.icon}
              </div>
              <h4 className="font-bold text-gray-800 text-lg" data-id="element-97">{item.title}</h4>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-98">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}